import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Trans } from 'react-i18next'

import styled from 'styled-components'

import HeadsetMic from '@material-ui/icons/HeadsetMic'
import MuiIconButton from '@material-ui/core/IconButton'
import MuiPopover from '@material-ui/core/Popover'
import MuiMenuItem from '@material-ui/core/MenuItem'

const StyleHelpWhat = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 30px;
  right: 8px;
  bottom: 8px;
  background-color: #02b326;
  z-index: 90;
`

const openExternalLink = url => window.open(url, '_blank', 'noopener,noreferrer')

const CsgButtonSupport = ({ linkWhatsApp, linkFreshDesk }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const hasWhatsApp = !!linkWhatsApp
  const hasFreshDesk = !!linkFreshDesk
  const bothAvailable = hasWhatsApp && hasFreshDesk

  if (!hasWhatsApp && !hasFreshDesk) return null

  const handleClick = e => {
    if (bothAvailable) {
      setAnchorEl(e.currentTarget)
    } else if (hasFreshDesk) {
      openExternalLink(linkFreshDesk)
    } else {
      openExternalLink(linkWhatsApp)
    }
  }

  const handleClose = () => setAnchorEl(null)

  return (
    <StyleHelpWhat>
      <MuiIconButton type="button" aria-label="Support" onClick={handleClick}>
        <HeadsetMic />
      </MuiIconButton>
      {bothAvailable && (
        <MuiPopover
          open={!!anchorEl}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
          transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <MuiMenuItem
            onClick={() => {
              handleClose()
              openExternalLink(linkFreshDesk)
            }}
          >
            <Trans i18nKey="open_ticket" />
          </MuiMenuItem>
          <MuiMenuItem
            onClick={() => {
              handleClose()
              openExternalLink(linkWhatsApp)
            }}
          >
            WhatsApp
          </MuiMenuItem>
        </MuiPopover>
      )}
    </StyleHelpWhat>
  )
}

CsgButtonSupport.propTypes = {
  linkWhatsApp: PropTypes.string,
  linkFreshDesk: PropTypes.string
}

export default CsgButtonSupport
